<script lang="ts">
  import type { PageData } from './$types';
  import {
    AdScripts,
    SEO,
    SiteHeader,
    SiteFooter,
    EmbedPreviewerLink,
    LeaderboardAd,
    Theme,
  } from '@reuters-graphics/graphics-components';
  import App from '$lib/App.svelte';
  import pkg from '$pkg';
  import { dev } from '$app/environment';
  import { asset } from '$app/paths';
  import { page } from '$app/state';
  import { isReutersApp, isReutersDev, isReutersDotcom } from '$utils/env';
  import LogBlock from '$lib/components/dev/LogBlock.svelte';

  // Styles
  import '@reuters-graphics/graphics-components/scss/main.scss';
  import '$lib/styles/global.scss';

  let { data }: { data: PageData } = $props();
  let content = $derived(data.content);
</script>

{#if isReutersDotcom(page.url)}
  <AdScripts />
{/if}

<SEO
  baseUrl={__BASE_URL__}
  pageUrl={page.url}
  seoTitle={content.seoTitle}
  seoDescription={content.seoDescription}
  shareTitle={content.shareTitle}
  shareDescription={content.shareDescription}
  shareImgPath={asset(`/${content.shareImgPath}`)}
  shareImgAlt={content.shareImgAlt}
  shareImgWidth={1200}
  shareImgHeight={628}
  publishTime={pkg?.reuters?.graphic?.published}
  updateTime={pkg?.reuters?.graphic?.updated}
  authors={pkg?.reuters?.graphic?.authors}
  articleSection={content.section}
  keywords={content.keywords
    ?.split(',')
    .map((k) => k.trim())
    .filter(Boolean)}
  locale={content.locale}
/>

<Theme base="light">
  {#if !isReutersApp(page.url)}
    <!-- {#if isReutersDotcom(page.url)}
      <LeaderboardAd />
    {:else if isReutersDev(page.url)}
      <LogBlock level="info" message="An ad will appear here on dotcom" />
    {/if} -->
    <SiteHeader />
  {/if}

  <App {content} />

  {#if !isReutersApp(page.url)}
    <SiteFooter />
  {/if}
</Theme>

<!-- Only visible in dev! -->
<EmbedPreviewerLink {dev} />
